import { render } from "./Application_Fees.vue?vue&type=template&id=96baaa02"
import script from "./Application_Fees.vue?vue&type=script&lang=js"
export * from "./Application_Fees.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__